import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getDisputesCount,
  getDisputesForPaginationMuthoot,
} from "slices/disputeSlice";
import DisputesMuthoot from "./DisputesMuthoot";
import { ROWS_PER_PAGE } from "./config";
import { usePagination } from "hooks";

export default function DisputesContainerMuthoot() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile, shallowEqual);
  const user = useSelector((state) => state.user.user);
  const { page, setPage, totalPages, syncWithBackend } = usePagination({
    initialPageSize: ROWS_PER_PAGE,
    initialPage: 1,
  });

  const [count, setCount] = useState({ received: {}, registered: {} });
  const [countLoading, setCountLoading] = useState(true);

  let sessionType = sessionStorage.getItem("muthoot-type");

  const [type, setType] = useState(sessionType ? sessionType : 'totalcases');
  const [disputes, setDisputes] = useState([]);
  const [disputesLoading, setDisputesLoading] = useState(false);
  const [region, setRegion] = useState(null);
  const [days, setDays] = useState(null);
  const [product, setProduct] = useState('');
  const [grievanceType, setGrievanceType] = useState(null);

  React.useEffect(() => {
    const params = {
      product,
    }
    dispatch(getDisputesCount(params)).then((res) => {
      setCount(res);
      setCountLoading(false);
    });
    // reload()
  }, [product]);

  useEffect(()=>{
    reload(type,region,days,product,grievanceType);
  },[type,region,days,product,grievanceType])


  const reload = (newType = type, newregion = region, newdays = days, newproduct = product, newgrievanceType = grievanceType) => {
    setDisputesLoading(true);
    // setCurrentPage(1);
    setPage(1);
    dispatch(getDisputesForPaginationMuthoot(page, newType, newregion, newdays, newproduct, newgrievanceType)).then((res) => {
      // let count = res.count;
      // let t = parseInt(count / ROWS_PER_PAGE);
      // let r = count % ROWS_PER_PAGE;
      // let total = t + (r > 0 ? 1 : 0);
      syncWithBackend({ totalCount: res?.count, next: res?.next, previous: res?.previous });
      // setTotalPages(total);
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  const getUserDataAnotherPage = (pageNo) => {
    if(pageNo === page) return;
    setPage(pageNo)
    setDisputesLoading(true);
    dispatch(getDisputesForPaginationMuthoot(pageNo, type, region, days, product, grievanceType)).then((res) => {
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  let childProps = {
    disputes,
    profile,
    user,
    count,
    countLoading,
    disputesLoading,
    setType,
    type,
    reload,
    totalPages,
    page,
    setPage,
    getUserDataAnotherPage,
    region,
    setRegion,
    days,
    setDays,
    product,
    setProduct,
    grievanceType,
    setGrievanceType,
  };

  if (countLoading) return <CircularCenteredLoader />;
  return <DisputesMuthoot {...childProps} />;
}
